import Box from '@mui/material/Box';
import React from 'react';
import { StopeLocationDto } from 'providers/api/api';
import StopeList from './StopeList';
import { Model } from '../hooks/useModelState';
import { PCNode } from '../MineModel/Nodes';
import { SceneProps } from '../Scenes/scene-utils';

interface StopesPanelPageProps {
  model: Model;
  onSelect: (model: Model, node: PCNode, props: SceneProps, stopeId?: string) => void;
  onHover: (stopeLocation?: StopeLocationDto) => void;
  props: SceneProps;
}

const StopesPanelPage = ({
  model,
  onSelect,
  onHover,
  props,
}: StopesPanelPageProps) => {
  const [activeNodeId, setActiveNodeId] = React.useState<string | undefined>();
  const searchHighlightRef = React.useRef<{ nodeId: string; hadArrow: boolean } | null>(null);
  const modelRef = React.useRef(model);

  // A picked node is marked with its constraint arrow, unless it already had one of its own.
  const handleNodePick = (nodeId?: string) => {
    const previous = searchHighlightRef.current;
    if (previous?.nodeId === nodeId) return;
    if (previous && !previous.hadArrow) {
      model.setNodeConstraint(previous.nodeId, false);
    }
    searchHighlightRef.current = null;

    if (nodeId) {
      const hadArrow = model.nodes?.[nodeId]?.showConstraintArrow ?? false;
      if (!hadArrow) {
        model.setNodeConstraint(nodeId, true);
      }
      searchHighlightRef.current = { nodeId, hadArrow };
    }
    setActiveNodeId(nodeId);
  };

  React.useEffect(() => {
    modelRef.current = model;
  }, [model]);

  React.useEffect(() => () => {
    const previous = searchHighlightRef.current;
    if (previous && !previous.hadArrow) {
      modelRef.current.setNodeConstraint(previous.nodeId, false);
    }
  }, []);

  return (
    <Box
      sx={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        borderRadius: '8px',
        width: '100%',
      }}
    >
      <StopeList
        model={model}
        activeNodeId={activeNodeId}
        onNodePick={handleNodePick}
        onSelect={onSelect}
        onHover={onHover}
        props={props}
      />
    </Box>
  );
};

export default StopesPanelPage;
